// Exported so pages/products/debtpulse can emit FAQPage schema from the same copy.
export const faqs = [
  {
    question: "How long does implementation take?",
    answer:
      "DebtPulse can be deployed in hours, not weeks. Our self-hosted option allows you to get started immediately, while our managed SaaS option includes onboarding support to ensure a smooth transition.",
  },
  {
    question: "Can we integrate with our LOS/LMS?",
    answer:
      "Yes, DebtPulse offers a modern API-first architecture that integrates seamlessly with most Loan Origination Systems (LOS) and Loan Management Systems (LMS). We also support CSV imports for quick data migration.",
  },
  {
    question: "Does it support multi-branch operations?",
    answer:
      "Absolutely. DebtPulse is built for multi-branch, multi-team operations with role-based access control, branch-level reporting, and centralized portfolio management across all locations.",
  },
  {
    question: "Is data hosted in India?",
    answer:
      "Yes, for our managed SaaS option, all data is hosted in India-based data centers. For self-hosted deployments, you have complete control over where your data resides.",
  },
  {
    question: "How does AI scoring work?",
    answer:
      "Our AI scoring engine analyzes multiple factors including DPD (Days Past Due), payment history, borrower behavior, loan amount, and engagement patterns to assign a risk score (0-100) to each account. This helps agents prioritize high-value, high-risk accounts first.",
  },
  {
    question: "What compliance features are included?",
    answer:
      "DebtPulse includes built-in quiet hours enforcement, contact frequency caps, opt-out tracking, and full audit trails to ensure your collection operations stay RBI-compliant at all times.",
  },
];

export default function FaqSection() {
  return (
    <section
      className="py-24 px-5 md:px-20"
      style={{
        background:
          "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(250,245,255,1) 100%)",
      }}
    >
      <div className="max-w-4xl mx-auto px-0 md:px-8 flex flex-col gap-16">
        {/* Header */}
        <div className="flex flex-col gap-4 items-center justify-center">
          <div className="bg-white rounded-full border border-[#bae6fd] pt-2 pr-4 pb-2 pl-4 shadow-sm">
            <span
              className="text-[#0369a1] font-bold text-xs leading-4 uppercase"
              style={{ letterSpacing: "0.6px" }}
            >
              faq
            </span>
          </div>
          <h2 className="text-[#111827] text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold">
            Frequently Asked Questions
          </h2>
        </div>

        {/* FAQ List */}
        <div className="flex flex-col gap-6">
          {faqs.map((faq) => (
            <div
              key={faq.question}
              className="bg-white rounded-3xl border border-[#f3f4f6] p-8 flex flex-col gap-4 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]"
            >
              <h3 className="text-[#111827] font-['SpaceGrotesk-Bold',_sans-serif] text-xl leading-7 font-bold">
                {faq.question}
              </h3>
              <p className="text-[#4b5563] font-normal text-base leading-[26px]">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
